import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { useThinkingPhase } from '../../hooks/useThinkingPhase';
import ChatAssistantAvatar from './ChatAssistantAvatar';

/** Escalating wording, so a long wait does not read as a hang. */
const THINKING_KEYS = ['chat.thinking', 'chat.stillThinking', 'chat.almostThere'];

/** Placeholder turn shown while the assistant's reply streams. */
const ChatThinkingRow: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const { t } = useTranslation();
  const phase = useThinkingPhase(isLoading);

  if (!isLoading) return null;

  return (
    <div className="mb-4 flex items-center gap-3" role="status" aria-live="polite">
      <ChatAssistantAvatar />
      <span className="flex items-center gap-2 text-sm text-muted-foreground">
        <Loader2 className="size-4 animate-spin motion-reduce:animate-none" strokeWidth={2} />
        {/* Shimmer only the word — not the row, or it would clip the spinner away. */}
        <span className="revy-shimmer">{t(THINKING_KEYS[phase])}</span>
      </span>
    </div>
  );
};

export default ChatThinkingRow;
